"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanTasks = exports.allTasks = exports.task = exports.startTask = void 0;
let tasks = 0;
let resolves = [];
function startTask() {
    tasks += 1;
    return () => {
        tasks -= 1;
        if (tasks === 0) {
            let prevResolves = resolves;
            resolves = [];
            for (let i of prevResolves)
                i();
        }
    };
}
exports.startTask = startTask;
function task(cb) {
    let endTask = startTask();
    return cb().finally(endTask);
}
exports.task = task;
function allTasks() {
    if (tasks === 0) {
        return Promise.resolve();
    }
    else {
        return new Promise(resolve => {
            resolves.push(resolve);
        });
    }
}
exports.allTasks = allTasks;
function cleanTasks() {
    tasks = 0;
}
exports.cleanTasks = cleanTasks;
